import { PublicApiClient } from '@/services/PublicApiClient'

export default {
  getOverduePaymentInformation(hash) {
    return PublicApiClient.get(
      'overdue-payment-reminder/' + hash,
      {
        responseType: 'arraybuffer'
      }
    );
  }
}
